import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Container, Card, Button, Spinner, Alert } from 'react-bootstrap';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { subscriberService } from '../services/api';
import './UnsubscribePage.css';

const UnsubscribePage = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [email, setEmail] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setError('Invalid unsubscribe link');
      setLoading(false);
      return;
    }

    handleUnsubscribe(token);
  }, [searchParams]);

  const handleUnsubscribe = async (token) => {
    try {
      const response = await subscriberService.unsubscribe(token);
      setSuccess(true);
      setEmail(response.data.email);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to unsubscribe');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="unsubscribe-page">
        <Container>
          <div className="unsubscribe-card">
            <Spinner animation="border" variant="primary" />
            <p className="mt-3">Processing your request...</p>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="unsubscribe-page">
      <Container>
        <Card className="unsubscribe-card">
          {success ? (
            <>
              <div className="icon-success">
                <FaCheckCircle />
              </div>
              <h1>Successfully Unsubscribed</h1>
              <p className="email-text">{email}</p>
              <p className="message">
                You've been removed from our newsletter list. You won't receive any more emails from us.
              </p>
              <p className="message secondary">
                We're sorry to see you go! If you change your mind, you can always subscribe again from our blog page.
              </p>
              <div className="actions">
                <Link to="/blog">
                  <Button variant="primary" className="action-btn">
                    Browse Our Blog
                  </Button>
                </Link>
                <Link to="/">
                  <Button variant="outline-primary" className="action-btn">
                    Back to Home
                  </Button>
                </Link>
              </div>
            </>
          ) : (
            <>
              <div className="icon-error">
                <FaTimesCircle />
              </div>
              <h1>Unsubscribe Failed</h1>
              <Alert variant="danger" className="mt-3">
                {error}
              </Alert>
              <p className="message">
                The unsubscribe link may be invalid or expired. If you're still receiving emails, please contact us for assistance.
              </p>
              <div className="actions">
                <Link to="/">
                  <Button variant="primary" className="action-btn">
                    Back to Home
                  </Button>
                </Link>
              </div>
            </>
          )}
        </Card>
      </Container>
    </div>
  );
};

export default UnsubscribePage;
